import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useHasPermission } from '@/hooks/useHasPermission';
import { routePaths } from '@/routes/paths';

type RequirePermissionProps = PropsWithChildren<{
  permission: string | string[];
}>;

export function RequirePermission({ permission, children }: RequirePermissionProps) {
  const location = useLocation();
  const hasPermission = useHasPermission(permission);

  if (!hasPermission) {
    return <Navigate to={routePaths.app.dashboard} replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
